import { useProviders } from '@/hooks'
import { useUIStore } from '@/stores'
import { useT, useLanguageStore, languageNames, type Language } from '@/i18n'
import { useThemeStore, type Theme } from '@/stores/theme'

const themeNames: Record<Theme, string> = {
  dark: 'Dark Mode',
  light: 'Light Mode',
  hack: 'Hack Mode',
}

export function Settings() {
  const { data: providers, isLoading } = useProviders()
  const { selectedProvider, setSelectedProvider } = useUIStore()
  const t = useT()
  const { language, setLanguage } = useLanguageStore()
  const { theme, setTheme } = useThemeStore()

  if (isLoading) return <div className="settings"><h1>{t.settingsTitle}</h1><p>{t.loading}</p></div>

  return (
    <div className="settings">
      <h1>{t.settingsTitle}</h1>

      <div className="settings-sections">
        <section className="settings-section">
          <h2>{t.settingsDefaults}</h2>
          <div className="settings-group">
            <label>
              <span>{t.settingsDefaultProvider}</span>
              <select value={selectedProvider} onChange={(e) => setSelectedProvider(e.target.value)}>
                {providers?.filter((p) => p.is_active).map((p) => (
                  <option key={p.provider_type} value={p.provider_type}>{p.display_name}</option>
                ))}
              </select>
            </label>
          </div>
        </section>

        <div className="settings-section">
          <h2>{t.settingsLanguage}</h2>
          <p className="section-description">{t.settingsLanguageDesc}</p>
          <div className="settings-group">
            <label>
              <span>{t.settingsLanguage}</span>
              <select value={language} onChange={(e) => setLanguage(e.target.value as Language)}>
                {(Object.entries(languageNames) as [Language, string][]).map(([code, name]) => (
                  <option key={code} value={code}>{name}</option>
                ))}
              </select>
            </label>
          </div>
        </div>

        <div className="settings-section">
          <h2>{t.settingsTheme}</h2>
          <p className="section-description">{t.settingsThemeDesc}</p>
          <div className="settings-theme-grid">
            {(Object.entries(themeNames) as [Theme, string][]).map(([key, name]) => (
              <button
                key={key}
                className={`settings-theme-card ${theme === key ? 'active' : ''}`}
                onClick={() => setTheme(key)}
              >
                <div className={`settings-theme-preview settings-theme-preview--${key}`}>
                  <div className="settings-theme-preview-sidebar" />
                  <div className="settings-theme-preview-content">
                    <div className="settings-theme-preview-line" />
                    <div className="settings-theme-preview-line short" />
                  </div>
                </div>
                <span>{name}</span>
              </button>
            ))}
          </div>
        </div>

        <section className="settings-section">
          <h2>{t.settingsAbout}</h2>
          <div className="about-info">
            <p><strong>Synapsios</strong> {t.settingsVersion}</p>
            <p>{t.settingsAboutDesc}</p>
            <p className="about-tech">{t.settingsAboutTech}</p>
          </div>
        </section>
      </div>
    </div>
  )
}
